/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 一括処理
 */
const setScrollTrigger = () => {
  setScrollTrigger__page();
};

/**
 * 初期値
 */
let actionOptions = { duration: 1, ease: 'power4.easeOut', overwrite: true, }
let triggerOptions = { start: `top 70%`, end: `bottom 70%`, once: true }

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __10:共通 - 指定クラスが特定の位置に来たらアニメーション実行処理
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @description - 共通アニメーション
 */
function setScrollTriggerInit(getTrigger, type = '') {

  // フェードイン
  const fadeIn = () => {
    let fadeIn__item = getTrigger.querySelectorAll('.--js_fadeIn__item');
    if (fadeIn__item.length > 0) {
      gsap.set(fadeIn__item, { opacity: 0, });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([fadeIn__item], { ...actionOptions, opacity: 1, stagger: 0.1, }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  // フェードアップ
  const fadeUp = () => {
    let fadeUp__item = getTrigger.querySelectorAll('.--js_fadeUp__item');
    if (fadeUp__item.length > 0) {
      gsap.set(fadeUp__item, { opacity: 0, y: "20%" });
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([fadeUp__item], { ...actionOptions, opacity: 1, y: 0, stagger: 0.1, }),
        ...triggerOptions,
        // markers: true,
      });
    }
  }

  //animation state
  const animationState = () => {
    let animationState = getTrigger.querySelectorAll('.--js_animationState__item');
    if (animationState.length > 0) {
      ScrollTrigger.batch(getTrigger, {
        onEnter: () => gsap.to([animationState], { animationPlayState: "running" }),
        onEnterBack: () => gsap.to([animationState], { animationPlayState: "paused" }),
        start: `top bottom`, end: `top bottom`, once: false
      });
    }
  }

  type == 'fadeIn' && fadeIn();
  type == 'fadeUp' && fadeUp();
  type == 'animationState' && animationState();
}

/**
 * __80:全ページ共通 - 指定クラスが特定の位置に来たらアニメーション実行処理
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @description - 下層ページ共通
 */
function setScrollTrigger__page() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger');
  setTrigger.forEach((getTrigger) => {
    setScrollTriggerInit(getTrigger, 'fadeIn');
    setScrollTriggerInit(getTrigger, 'fadeUp');
    setScrollTriggerInit(getTrigger, 'animationState');
  });
}

/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setScrollTrigger
};